const check = {
  email(val) {
    const reg1 = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/ //正则表达式
    return reg1.test(val)
  },

  website(val) {
    const reg = /^(http(s)?:\/\/)\w+[^\s]+(\.[^\s]+){1,}$/
    return reg.test(val)
  },

  numberAndLetter(val) {
    const reg = /^[A-Za-z0-9]+$/
    return reg.test(val)
  },

  orcid(val) {
    const reg1 = /^(([0-9A-Za-z]{4,4})-){3,3}[0-9A-Za-z]{4,4}\b$/
    const reg2 = /^[0-9A-Za-z]{16,16}$/
    if (!val) {
      return true
    }
    if (val.match(reg1) || val.match(reg2)) {
      return true
    } else {
      return false
    }
  }
}

export default check
